import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavbarComponent } from './navbar/navbar.component';
import { NoAcessComponent } from './no-acess/no-acess.component';

const routes: Routes = [

  { path:'noaccess',component:NoAcessComponent},
 
  // { path: 'navbar', component:NavbarComponent,canActivate:[AuthService] },
  
  { path: '', component:NavbarComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers:[]
})
export class AppRoutingModule { }
